export const orderNeedToBeReminded = (
  paymentMethod,
  status,
  reminded,
  createdAt
) => {
  const timeBeforeRemind = 2 * (7 * 24 * 60 * 60 * 1000);
  const now = new Date();
  if (paymentMethod !== 'cb' || status !== 'A_PAYER' || reminded) return false;
  if (
    new Date(createdAt).getTime() <
    new Date(now.getTime() - timeBeforeRemind).getTime()
  )
    return true;
  return false;
};
